export const LIST_PAGES = {
  "kashmir-tour-packages": {
    title: "Kashmir Tour Packages",
    seoTitle: "Kashmir Tour Packages | Srinagar, Gulmarg, Pahalgam | Book Kashmir",
    seoDesc: "Explore personalised Kashmir tour packages covering Srinagar, Gulmarg, Pahalgam, Sonamarg and more. Comfortable stays, private transfers and custom itineraries.",
    subtitle: "Handcrafted Kashmir holidays for couples, families, friends and groups — every itinerary personalised around your dates and budget.",
    filter: () => true,
  },
  "kashmir-honeymoon-packages": {
    title: "Kashmir Honeymoon Packages",
    seoTitle: "Kashmir Honeymoon Packages | Romantic Kashmir Holidays | Book Kashmir",
    seoDesc: "Romantic Kashmir honeymoon packages with houseboat stays on Dal Lake, Shikara rides, Gulmarg snow and private transfers. Personalised for couples.",
    subtitle: "Houseboat nights, private Shikara rides and snow-kissed meadows — honeymoon holidays designed just for the two of you.",
    filter: (p) => p.categories.includes("honeymoon"),
  },
  "kashmir-family-packages": {
    title: "Kashmir Family Packages",
    seoTitle: "Kashmir Family Packages | Family Holidays in Kashmir | Book Kashmir",
    seoDesc: "Comfortable Kashmir family holiday packages with family-friendly hotels, private vehicles and flexible sightseeing across Srinagar, Gulmarg and Pahalgam.",
    subtitle: "Comfortable pacing, family-friendly stays and private vehicles — Kashmir holidays the whole family will love.",
    filter: (p) => p.categories.includes("family"),
  },
  "kashmir-couple-packages": {
    title: "Kashmir Couple Packages",
    seoTitle: "Kashmir Couple Packages | Romantic Getaways | Book Kashmir",
    seoDesc: "Kashmir packages for couples — romantic stays, private transfers, Shikara rides and flexible itineraries across Srinagar, Gulmarg and Pahalgam.",
    subtitle: "Quiet lakes, mountain sunsets and stays made for two — Kashmir getaways crafted for couples.",
    filter: (p) => p.categories.includes("couple") || p.categories.includes("honeymoon"),
  },
  "gulmarg-tour-packages": {
    title: "Gulmarg Tour Packages",
    seoTitle: "Gulmarg Tour Packages | Snow, Gondola & Meadows | Book Kashmir",
    seoDesc: "Gulmarg tour packages with Gondola rides, snow experiences and meadow stays, combined with Srinagar and Pahalgam. Personalised Kashmir holidays.",
    subtitle: "Snow, the famous Gondola and endless meadows — packages that make Gulmarg the heart of your Kashmir holiday.",
    filter: (p) => p.destinations.includes("gulmarg"),
  },
  "pahalgam-tour-packages": {
    title: "Pahalgam Tour Packages",
    seoTitle: "Pahalgam Tour Packages | Lidder Valley Holidays | Book Kashmir",
    seoDesc: "Pahalgam tour packages covering the Lidder valley, Betaab Valley and Aru, with comfortable stays and private transfers from Srinagar.",
    subtitle: "Riverside calm, pine forests and the beautiful Lidder valley — Kashmir holidays centred on Pahalgam.",
    filter: (p) => p.destinations.includes("pahalgam"),
  },
  "srinagar-tour-packages": {
    title: "Srinagar Tour Packages",
    seoTitle: "Srinagar Tour Packages | Dal Lake & Houseboats | Book Kashmir",
    seoDesc: "Srinagar tour packages with Dal Lake houseboat stays, Shikara rides, Mughal gardens and old-city experiences, plus day trips to Gulmarg and Pahalgam.",
    subtitle: "Dal Lake houseboats, Mughal gardens and the charm of the old city — begin your Kashmir story in Srinagar.",
    filter: (p) => p.destinations.includes("srinagar"),
  },
};
